export default "__VITE_ASSET__BTHS$kXZ__"